import React, { useEffect, useState } from "react";
import ReusableTable from "../../../components/common/table";
import { Avatar, Button, Dropdown, Menu, message, Space, Tag } from "antd";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import ConfirmModal from "../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../assets/images/action/Shield Cross.svg";
import { ReactComponent as UploadSvg } from "../../../assets/images/cloud-upload.svg";
import { ReactComponent as ManualUploadSvg } from "../../../assets/images/document-upload.svg";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { ReactComponent as EnableSvg } from "../../../assets/images/action/Shield Check.svg";
import BulkUploadModal from "./BulkUploadModal";
import CommonFilter from "../../../components/common/filter";
import {
  deleteUser,
  getUserData,
  updateStatus,
} from "../../../redux/action/user-management/userManagementAction";
import { useDispatch, useSelector } from "react-redux";
import trimSearchValue, { useDebounce } from "../../../customHooks";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";
import ResetPasswordModal from "./ResetPasswordFormModal";

const UserManagement = () => {
  const navigate = useNavigate();
  const [bulkUpload, setBulkUpload] = useState(false);
  const dispatch = useDispatch();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserStatus, setSelectedUserStatus] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [resetModel, setResetModel] = useState({
    userId: "",
    state: false,
  });

  const getInitialParams = () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 10;
    const search_key = searchParams.get("search_key") || "all";
    const search_value = searchParams.get("search_value") || "";
    const status = searchParams.get("status");

    return {
      page,
      size,
      search_key,
      search_value,
      status: status !== null ? Number(status) : undefined,
    };
  };

  const firstLoad = localStorage.getItem("firstLoad");

  const location = useLocation();

  console.log(location, "smjkdskjdfg");

  const [tableParams, setTableParams] = useState(getInitialParams());

  useEffect(() => {
    const params = {
      page: tableParams.page,
      size: tableParams.size,
      search_key: tableParams.search_key,
      search_value: tableParams.search_value,
    };
    if (tableParams.status !== undefined) {
      params.status = tableParams.status;
    }
    setSearchParams(params);
  }, [tableParams, setSearchParams]);

  // set page refresh end

  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });

  const showModal = (actionType, userId = null, status = null) => {
    setSelectedUserId(userId);
    setSelectedUserStatus(status);
    setModalConfig({ open: true, actionType });
  };

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
    setSelectedUserStatus(null);
    setSelectedUserId(null);
  };

  const handleConfirm = () => {
    closeModal();
  };

  const columns = [
    {
      title: "SR. NO.",
      dataIndex: "id",
      key: "id",
      width: "80px",
      render: (text, record, index) =>
        (tableParams.page - 1) * tableParams.size + index + 1,
    },
    {
      title: "User Name",
      dataIndex: "name_en",
      key: "name_en",
      type: "search",
    },
    {
      title: "Total Listening Time",
      dataIndex: "total_listen_duration",
      key: "total_listen_duration",
      // type: "search",
      width: "160px",
      render: (durationInSeconds) => {
        const hours = Math.floor(durationInSeconds / 3600);
        const minutes = Math.floor((durationInSeconds % 3600) / 60);
        const seconds = durationInSeconds % 60;

        let result = "";
        if (hours > 0) result += `${hours}h `;
        if (minutes > 0 || hours > 0) result += `${minutes}m `;
        result += `${seconds}s`;

        return result.trim();
      },
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
      type: "search",
    },
    {
      title: "Image",
      dataIndex: "profile_pic",
      key: "profile_pic",
      render: (image) =>
        image ? (
          <img
            src={
              image
                ? `${process.env.REACT_APP_API_IMG_URI}/${image}`
                : undefined
            }
            alt={image}
            style={{ width: 50, height: 50, borderRadius: "50%" }}
          />
        ) : (
          <Avatar size={50} icon={<UserOutlined />} />
        ),
    },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "created_at",
      type: "date",
      render: (created_at) =>
        created_at ? dayjs(created_at).format("MM-DD-YYYY") : "-",
    },

    {
      title: "Activation Date",
      dataIndex: "activation_date",
      key: "act_created_at",
      type: "act_date",
      render: (created_at) =>
        created_at ? dayjs(created_at).format("MM-DD-YYYY") : "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      type: "select",
      render: (status) => {
        const isActive = status === 1;
        return (
          <Tag
            color={isActive ? "#E6F4EA" : "#FCE8E8"}
            style={{
              color: isActive ? "#22AD5C" : "#FF5D5D",
            }}
            className="custom-tag"
          >
            {isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
      options: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
      ],
    },
  ];

  const actionItems = (user) => [
    {
      key: "view",
      label: (
        <>
          <ViewSvg style={{ marginRight: 8, color: "red" }} />
          View Details
        </>
      ),
      onClick: () => navigate(`view-user/${user?.id}`),
    },
    {
      key: "edit",
      label: (
        <>
          <EditSvg style={{ marginRight: 8, color: "red" }} />
          Edit Details
        </>
      ),
      onClick: () => navigate(`edit-user/${user?.id}`),
    },
    {
      key: "reset-password", // New key for reset password
      label: (
        <>
          {/* Assuming ResetPasswordSvg is imported and styled */}
          {/* Changed color for distinction */}
          <EditSvg style={{ marginRight: 8, color: "red" }} />
          Reset Password
        </>
      ),
      onClick: () =>
        setResetModel((prev) => ({
          ...prev,
          userName: user?.name_en,
          userId: user?.id,
          state: true,
        })),
      // navigate(`user-reset-password/${user?.id}`), // Call showModal with 'reset-password' type
    },
    {
      key: "disable",
      label: (
        <>
          {user?.status === 1 ? (
            <>
              <DisableSvg style={{ marginRight: 8, color: "red" }} />
              Deactivate User
            </>
          ) : (
            <>
              <EnableSvg style={{ marginRight: 8 }} />
              Activate User
            </>
          )}
        </>
      ),
      onClick:
        user?.status === 1
          ? () => showModal("deactivate", user.id, user.status)
          : () => showModal("activate", user.id, user.status),
    },
    {
      key: "delete",
      label: (
        <>
          <DeleteSvg style={{ marginRight: 8, color: "red" }} />
          Delete User
        </>
      ),
      onClick: () => showModal("delete", user.id),
    },
  ];
  const handleMenuClick = ({ key }) => {
    if (key === "bulkUpload") {
      setBulkUpload(true);
    } else if (key === "ManualUpload") {
      navigate("add-user");
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="bulkUpload" icon={<ManualUploadSvg />}>
        Bulk User Upload
      </Menu.Item>
      <Menu.Item key="ManualUpload" icon={<UploadSvg />}>
        Manual User Entry
      </Menu.Item>
    </Menu>
  );

  const userOnCancel = () => {
    // setResetModel((prev) => ({ userId: "", state: false }))
    setResetModel(false);
  };

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  useEffect(() => {
    dispatch(getUserData(tableParams));
  }, [
    debouncedSearchValue,
    tableParams.status,
    tableParams.position,
    tableParams.page,
    tableParams.size,
    tableParams.from_date,
    tableParams.to_date,
    tableParams.act_from_date,
    tableParams.act_to_date,
  ]);

  useEffect(() => {
    if (firstLoad) {
      const today = new Date();
      const januaryFirst = new Date(today.getFullYear(), 0, 1);
      const { search_key, ...data } = {
        ...tableParams,
        act_from_date: januaryFirst.toISOString().split("T")[0],
        act_to_date: today.toISOString().split("T")[0],
      };

      setTableParams((prev) => ({
        ...tableParams,
        act_from_date: januaryFirst.toISOString().split("T")[0],
        act_to_date: today.toISOString().split("T")[0],
      }));

      dispatch(getUserData(data));

      localStorage.removeItem("firstLoad");
    }
  }, [firstLoad]);

  // const handleFilterChange = (key, value, reset = false) => {
  //   setTableParams((prev) => {
  //     if (reset) {
  //       return {
  //         ...prev,
  //         search_key: "",
  //         search_value: "",
  //         status: undefined,
  //         position: undefined,
  //       };
  //     }
  //     if (key === "status" || key === "position") {
  //       return {
  //         ...prev,
  //         [key]: value,
  //         search_key: "",
  //         search_value: "",
  //       };
  //     }
  //     return {
  //       ...prev,
  //       search_key: key,
  //       search_value: value,
  //       status: undefined,
  //       position: undefined,
  //     };
  //   });
  // };

  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
          from_date: undefined,
          to_date: undefined,
          act_from_date: undefined,
          act_to_date: undefined,
        };
      }
      if (key === "created_at" && (!value || !value.from_date)) {
        return {
          size: prev.size,
          page: prev.page,
        };
      }
      if (key === "act_created_at" && (!value || !value.act_from_date)) {
        return {
          size: prev.size,
          page: prev.page,
        };
      }
      if (key === "status" || key === "position") {
        return {
          ...prev,
          [key]: value,
          search_key: "",
          search_value: "",
        };
      }
      if (typeof value === "object" && value?.from_date) {
        return {
          ...prev,
          from_date: value?.from_date,
          to_date: value?.to_date,
          search_value: "",
          search_key: "",
          status: undefined,
          position: undefined,
        };
      }
      if (typeof value === "object" && value?.act_from_date) {
        return {
          ...prev,
          act_from_date: value?.act_from_date,
          act_to_date: value?.act_to_date,
          from_date: "",
          to_date: "",
          search_value: "",
          search_key: "",
          status: undefined,
          position: undefined,
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };

  const datas = useSelector((store) => store.getUserList?.data);
  const { isLoading } = useSelector((store) => store.getUserList);

  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: datas?.count ?? 0,
    current: tableParams.page,
    pageSize: tableParams.size,
    onChange: (page, pageSize) => {
      // setCurrentPage(page);
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };

  const handleDelete = () => {
    if (selectedUserId) {
      dispatch(
        deleteUser(
          { url: ApiUrl.CLIENT_USER_DATA_GET, id: `user_id=${selectedUserId}` },
          (res) => {
            if (res?.data?.code === 200) {
              dispatch(getUserData());
              closeModal();
            }
          }
        )
      );
    }
  };
  const handleUpdateStatus = (currentStatus) => {
    const newStatus = currentStatus === 0 ? 1 : 0;
    if (selectedUserId) {
      dispatch(
        updateStatus(
          {
            url: ApiUrl.CLIENT_USER_DATA_GET,
            id: `user_id=${selectedUserId}`,
            status: `status=${newStatus}`,
          },
          (res) => {
            if (res?.data?.code === 200) {
              dispatch(getUserData());
              closeModal();
            }
          }
        )
      );
    }
  };
  const handleTableChange = (pagination) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };

  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
            />
          </Space>
        </div>

        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <Button type="primary">
            Add Users <DownOutlined />
          </Button>
        </Dropdown>
      </div>
      <div className="tableHeading">List of User</div>
      <ReusableTable
        columns={columns}
        data={datas?.rows ?? []}
        paginationConfig={{
          ...paginationConfig,
          ...tableParams.pagination,
        }}
        handleTableChange={handleTableChange}
        actionItems={actionItems}
        loading={isLoading}
      />
      <ConfirmModal
        open={modalConfig.open}
        titlePrefix="User"
        messagePrefix="User"
        onClose={closeModal}
        onConfirm={
          modalConfig.actionType === "delete"
            ? handleDelete
            : () => handleUpdateStatus(selectedUserStatus)
        }
        actionType={modalConfig.actionType}
      />
      <BulkUploadModal
        open={bulkUpload}
        onClose={() => setBulkUpload(false)}
        onConfirm={handleConfirm}
      />
      <ResetPasswordModal
        userId={resetModel.userId}
        onCancel={userOnCancel}
        resetModel={resetModel}
        setResetModel={setResetModel}
        visible={resetModel.state ? true : false}
      />
    </div>
  );
};

export default UserManagement;
